export default __webpack_public_path__ + "static/media/ig_icon.dc209f76.svg";